var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"label":"Jupyter Mode"}},[_c('menu-item',{attrs:{"label":"Screen shot"},on:{"click":_vm.screenshot}}),_c('menu-item',{attrs:{"label":"Wait!","keybind":"shift+w"},on:{"click":_vm.wait}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }